import React from "react";
import { AlertTriangle } from "lucide-react";
import { fmtUSD, fmtMonthLabel } from "../lib/format";
import { Input } from "./ui/input";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "./ui/select";
import { useI18n } from "../lib/i18n";

export default function MobileMonthCards({ rows, inputs, updateInput }) {
  const { t, lang } = useI18n();

  return (
    <div className="wc-mobile-list" data-testid="mobile-list">
      {rows.map((row, idx) => {
        const rowInput = inputs[idx];
        return (
          <div
            key={idx}
            className={
              "wc-mob-card" +
              (row.is_year_start ? " wc-mob-card-year" : "") +
              (row.warning ? " wc-mob-card-warn" : "")
            }
            data-testid={`mob-row-${idx}`}
          >
            <div className="wc-mob-head">
              <span className="wc-mob-idx">{idx + 1}</span>
              <span className="wc-mob-label">{fmtMonthLabel(row, lang)}</span>
              {row.is_year_start && idx > 0 && <span className="wc-year-pill">{row.year}</span>}
              <span className="wc-mob-cap">{fmtUSD(row.capital_end, lang)}</span>
            </div>

            <div className="wc-mob-metrics">
              <div className="wc-mob-metric">
                <span>{t("col_profit")}</span>
                <b className="wc-td-profit">{fmtUSD(row.month_profit, lang)}</b>
              </div>
              <div className="wc-mob-metric">
                <span>{t("col_liq_end")}</span>
                <b>{fmtUSD(row.liquidity_end, lang)}</b>
              </div>
              <div className="wc-mob-metric">
                <span>{t("col_reinvested")}</span>
                <b className="wc-td-accent">{fmtUSD(row.reinvested, lang)}</b>
              </div>
            </div>

            <div className="wc-mob-inputs">
              <div className="wc-mob-input-block">
                <label>{t("col_deposit")}</label>
                <Input
                  type="number"
                  min="0"
                  step="100"
                  placeholder={t("input_deposit_ph")}
                  value={rowInput.deposit}
                  onChange={(e) => updateInput(idx, "deposit", e.target.value)}
                  className="wc-cell-input"
                  data-testid={`mob-deposit-${idx}`}
                />
              </div>
              <div className="wc-mob-input-block wc-mob-wd">
                <label>{t("col_withdrawal")}</label>
                <div className="wc-mob-wd-row">
                  <Input
                    type="number"
                    min="0"
                    placeholder={t("input_wd_ph")}
                    value={rowInput.withdrawal_value}
                    onChange={(e) => updateInput(idx, "withdrawal_value", e.target.value)}
                    className="wc-cell-input wc-cell-input-sm"
                    data-testid={`mob-wd-value-${idx}`}
                  />
                  <Select
                    value={rowInput.withdrawal_type}
                    onValueChange={(v) => updateInput(idx, "withdrawal_type", v)}
                  >
                    <SelectTrigger className="wc-select-mini" data-testid={`mob-wd-type-${idx}`}>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="usd">USD</SelectItem>
                      <SelectItem value="pct">%</SelectItem>
                    </SelectContent>
                  </Select>
                  <Select
                    value={rowInput.withdrawal_mode}
                    onValueChange={(v) => updateInput(idx, "withdrawal_mode", v)}
                  >
                    <SelectTrigger className="wc-select-mini" data-testid={`mob-wd-mode-${idx}`}>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="none">{t("mode_none")}</SelectItem>
                      <SelectItem value="spot">{t("mode_spot")}</SelectItem>
                      <SelectItem value="continuous">{t("mode_continuous")}</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                {row.withdrawal > 0 && (
                  <div className={"wc-mob-wd-out " + (row.warning ? "wc-wd-warn" : "wc-wd-ok")}>
                    {row.warning && <AlertTriangle size={12} />} {fmtUSD(row.withdrawal, lang)}
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
